import { ApprovalsSortType, SortType, FeatureFlagsSortType, AutomationsToolboxSortType } from '../types/sorts';

export const UPDATE_FEATURE_ITEMS_SORT = 'UPDATE_FEATURE_ITEMS_SORT';
export const UPDATE_AUTOMATIONS_TOOLBOX_SORT = 'UPDATE_AUTOMATIONS_TOOLBOX_SORT';
export const UPDATE_FEATURE_FLAGS_SORT = 'UPDATE_FEATURE_FLAGS_SORT';
export const UPDATE_APPROVALS_SORT = 'UPDATE_APPROVALS_SORT';

export interface SortFeatureItemsPayload {
    sortType: SortType;
    appId: string;
}

export interface SortAutomationsToolboxPayload {
    sortType: AutomationsToolboxSortType;
}

export interface SortFeatureFlagsPayload {
    sortType: FeatureFlagsSortType;
}

export interface SortApprovalsPayload {
    sortType: ApprovalsSortType;
}

// Actions

export interface UpdateFeatureItemsSortAction {
    type: typeof UPDATE_FEATURE_ITEMS_SORT;
    payload: SortFeatureItemsPayload;
}

export interface UpdateAutomationsToolboxSortAction {
    type: typeof UPDATE_AUTOMATIONS_TOOLBOX_SORT;
    payload: SortAutomationsToolboxPayload;
}
export interface UpdateFeatureFlagsSortAction {
    type: typeof UPDATE_FEATURE_FLAGS_SORT;
    payload: SortFeatureFlagsPayload;
}

export interface UpdateApprovalsSortAction {
    type: typeof UPDATE_APPROVALS_SORT;
    payload: SortApprovalsPayload;
}

// Action creators

export const updateFeatureItemsSort: (payload: SortFeatureItemsPayload) => UpdateFeatureItemsSortAction = (payload) => {
    return {
        type: UPDATE_FEATURE_ITEMS_SORT,
        payload,
    };
};

export const updateAutomationsToolboxSort: (
    payload: SortAutomationsToolboxPayload,
) => UpdateAutomationsToolboxSortAction = (payload) => {
    return {
        type: UPDATE_AUTOMATIONS_TOOLBOX_SORT,
        payload,
    };
};

export const updateFeatureFlagsSort: (payload: SortFeatureFlagsPayload) => UpdateFeatureFlagsSortAction = (payload) => {
    return {
        type: UPDATE_FEATURE_FLAGS_SORT,
        payload,
    };
};

export const updateApprovalsSort: (payload: SortApprovalsPayload) => UpdateApprovalsSortAction = (payload) => {
    return {
        type: UPDATE_APPROVALS_SORT,
        payload,
    };
};
